module.exports = __webpack_public_path__ + "images/a0e52f677347fc5cb7bf4a229b95c559-library_borrow.png";